import React from 'react'
import { connect } from 'react-redux'
import {
  Label,
  Button,
  Icon,
  Popup,
  Responsive
} from 'semantic-ui-react'
// Local
import { allowEncounterCDIHCCGroupRemove } from '../../common/currentUserUtils'
import {
  formatIcd10Code,
  displayRiskCode
} from '../../common/formatUtils'
import {
  CONDITION,
  shouldRenderReskin2025
} from '../../../constant'
import AddressedIcon from '../common/addressedIcon'
import { EncounterConditionDisplay } from '../../authenticated/types'
import If from '../../common/if'
import { RootState } from '../../../store'

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  active?: boolean | undefined
  conditions: EncounterConditionDisplay[]
  hccCode: string
  hccDescription?: string | undefined | null
  onConditionAction: (
    action: keyof typeof CONDITION.ACTION,
    condition: EncounterConditionDisplay[] | EncounterConditionDisplay | string
  ) => void
  onEditMode: boolean
}

function CdiConditionHccHeaderTitle(
  props: Props
): JSX.Element {
  const {
    active: isTitleActive,
    conditions,
    currentUser,
    hccCode,
    hccDescription,
    onConditionAction,
    onEditMode: isEditMode
  } = props

  const isActive = !!isTitleActive
  const shouldAllowCDIRemove = allowEncounterCDIHCCGroupRemove(currentUser)

  const hccGroupId = () => {
    const description = hccDescription !== undefined
      ? hccDescription
      : ''
    const prefix = description && description.replaceAll(' ', '-').toLowerCase()
    return `${prefix}-${hccCode}`
  }

  const labelColor = isActive
    ? 'blue'
    : 'grey'

  const conditionHccTitle = () => {
    const icd10Codes = conditions
      .filter(
        (c: EncounterConditionDisplay) => c.icd10CodeJson && c.icd10CodeJson.length > 0
      )
      .map((c: EncounterConditionDisplay) => {
        if (c.icd10CodeJson) {
          return formatIcd10Code(c.icd10CodeJson[0])
        }
        return ''
      })
      .join(', ')
    const displayCode = displayRiskCode(hccCode)
    return (
      <span>
        <If isTrue={ !shouldRenderReskin2025 }>
          <Label
            pointing="right"
            color={ labelColor }
          >
            { displayCode }
          </Label>
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <Label className="reskin">
            { displayCode }
          </Label>
        </If>
        <span>&nbsp;</span>
        <span>
          <If isTrue={ isActive && !!hccDescription }>
            <strong>{ hccDescription }</strong>
          </If>
          <If isTrue={ !isActive }>
            { hccDescription }
          </If>
        </span>
        <span>&nbsp;</span>
        <If isTrue={ icd10Codes.length > 0 }>
          <span className="italic">
            { icd10Codes }
          </span>
        </If>
      </span>
    )
  }

  const titleText = conditionHccTitle()

  const onClick = (e: { stopPropagation: () => void }) => {
    e.stopPropagation()
    onConditionAction(
      CONDITION.ACTION.MARK_REMOVED_MULTIPLE,
      conditions
    )
  }

  const titleClassName = shouldRenderReskin2025
    ? 'flex-title hover reskin'
    : 'flex-title hover'

  const conditionTitle = shouldRenderReskin2025
    ? 'condition-title reskin'
    : 'condition-title'

  return (
    <div className="physician-condition-title">
      <div className={ titleClassName }>
        <AddressedIcon conditions={ conditions } />
        <div className={ conditionTitle }>
          <If isTrue={ isActive }>
            <strong>{ titleText }</strong>
          </If>
          <If isTrue={ !isActive }>
            { titleText }
          </If>
        </div>
        <If isTrue={ isEditMode && shouldAllowCDIRemove }>
          <div className="condition-toolbar">
            <div className="hover__no-hover" />
            <div className="hover__hover">
              <Popup
                content="Remove All Conditions for HCC"
                mouseEnterDelay={ 1000 }
                trigger={
                  <Responsive
                    as={ Button }
                    icon
                    basic
                    size="mini"
                    id={ `cdi-encounter-condition-hcc-group-${hccGroupId()}` }
                    onClick={ (e: { stopPropagation: () => void }) => { onClick(e) } }
                  >
                    <Icon name="trash alternate outline" />
                  </Responsive>
                } />
            </div>
          </div>
        </If>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(CdiConditionHccHeaderTitle)
